(function () {
  var root = document.getElementById("wholesale-invoices-root");
  if (!root) return;

  var statusEl = document.getElementById("wholesale-invoices-status");
  var tableEl = document.getElementById("wholesale-invoices-table");
  var customerId = root.getAttribute("data-shopify-customer-id") || "";
  var endpoint = root.getAttribute("data-endpoint") || "";
  var meta = document.querySelector('meta[name="supabase-anon-key"]');
  var anon = meta ? meta.getAttribute("content") : "";

  function money(n) {
    try {
      return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(n || 0));
    } catch (e) {
      return "$" + Number(n || 0).toFixed(2);
    }
  }

  function dateLabel(iso) {
    if (!iso) return "—";
    var d = new Date(iso);
    if (Number.isNaN(d.getTime())) return String(iso).slice(0, 10);
    return d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
  }

  function setStatus(text) {
    if (statusEl) statusEl.textContent = text;
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function downloadPdf(content, filename) {
    var binary = atob(content);
    var bytes = new Uint8Array(binary.length);
    for (var i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    var blob = new Blob([bytes], { type: "application/pdf" });
    var url = URL.createObjectURL(blob);
    var a = document.createElement("a");
    a.href = url;
    a.download = filename || "Black-Elm-Invoice.pdf";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }

  function headers() {
    var h = { "Content-Type": "application/json" };
    if (anon) {
      h.Authorization = "Bearer " + anon;
      h.apikey = anon;
    }
    return h;
  }

  function post(payload) {
    return fetch(endpoint, {
      method: "POST",
      headers: headers(),
      body: JSON.stringify(payload),
    }).then(function (resp) {
      return resp.json().then(function (body) {
        if (!resp.ok) throw new Error(body.error || "request_failed");
        return body;
      });
    });
  }

  function render(invoices) {
    if (!invoices || !invoices.length) {
      setStatus("No invoices yet. After an order is billed, the PDF will show up here.");
      return;
    }
    setStatus("");
    var rows = invoices.map(function (inv) {
      var label = inv.doc_number || inv.order_number || "Invoice";
      var po = inv.po_number ? String(inv.po_number) : "—";
      var channel = inv.channel === "bakery" ? "Bakery" : "Coffee";
      var actions = [];
      if (inv.has_pdf) {
        actions.push('<button type="button" class="button" data-invoice-id="' + escapeHtml(inv.id) + '">Download PDF</button>');
      }
      if (inv.pay_url) {
        actions.push('<a class="button" href="' + escapeHtml(inv.pay_url) + '" target="_blank" rel="noopener">View</a>');
      }
      if (!actions.length) actions.push("<span>—</span>");
      return (
        "<tr>" +
        "<td>" + channel + "</td>" +
        "<td>#" + escapeHtml(String(label).replace(/^#/, "")) + "</td>" +
        "<td>" + dateLabel(inv.date) + "</td>" +
        "<td>" + escapeHtml(po) + "</td>" +
        "<td>" + money(inv.amount) + "</td>" +
        "<td>" + money(inv.balance_due) + "</td>" +
        "<td>" + (inv.status === "paid" ? "Paid" : "Open") + "</td>" +
        "<td>" + actions.join(" ") + "</td>" +
        "</tr>"
      );
    }).join("");

    tableEl.hidden = false;
    tableEl.innerHTML =
      '<div style="overflow-x:auto;"><table class="be-invoices-table" style="width:100%;border-collapse:collapse;">' +
      "<thead><tr>" +
      "<th align='left'>Type</th><th align='left'>Invoice</th><th align='left'>Date</th><th align='left'>PO</th>" +
      "<th align='left'>Amount</th><th align='left'>Balance</th><th align='left'>Status</th><th></th>" +
      "</tr></thead><tbody>" + rows + "</tbody></table></div>";

    tableEl.querySelectorAll("[data-invoice-id]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = btn.getAttribute("data-invoice-id");
        btn.disabled = true;
        var previous = btn.textContent;
        btn.textContent = "Preparing…";
        post({
          action: "pdf",
          shopify_customer_id: customerId,
          ar_document_id: id,
        }).then(function (result) {
          downloadPdf(result.content, result.filename);
        }).catch(function () {
          setStatus("Could not download that PDF. Email orders@blackelm.coffee and we will resend it.");
        }).then(function () {
          btn.disabled = false;
          btn.textContent = previous;
        });
      });
    });
  }

  if (!customerId || !endpoint) {
    setStatus("Could not load invoices.");
    return;
  }

  post({ action: "list", shopify_customer_id: customerId })
    .then(function (result) {
      render(result.invoices || []);
    })
    .catch(function () {
      setStatus("Could not load invoices. Try again, or email orders@blackelm.coffee.");
    });
})();
